import { ref } from 'vue'
import { followList, addFollow } from '@/api/billWarning'
import { Message } from '@qs/ui'

export function useFollowDialog() {
  const visible = ref(false)
  const currentId = ref(null)
  const list = ref([])
  const content = ref('')
  const saving = ref(false)

  async function loadList() {
    const { code, data } = await followList({ bizId: currentId.value })
    if (code === 1) list.value = data || []
  }

  // 传入的 id 为应收记录 receivableId；作为 follow 接口入参 bizId(风险ID或应收ID)
  async function open(bizId) {
    currentId.value = bizId
    content.value = ''
    list.value = []
    visible.value = true
    await loadList()
  }

  async function save() {
    if (!content.value.trim()) return false
    saving.value = true
    try {
      const { code } = await addFollow({
        bizId: currentId.value,
        describe: content.value.trim(),
      })
      if (code === 1) {
        Message({ type: 'success', message: '跟进已保存' })
        // eslint-disable-next-line require-atomic-updates -- 弹窗保存按钮 loading 期间不可重入，无实际竞态
        content.value = ''
        await loadList()
        return true
      }
      return false
    } finally {
      saving.value = false
    }
  }

  function close() {
    visible.value = false
  }

  return { visible, list, content, saving, open, save, close }
}
